import { Label } from "./ui/label";

export default function FormError({ msg }: any) {
  return <Label className="relative text-xs text-destructive">{msg}</Label>;
}
